import { useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import toast from "react-hot-toast";
import api from "utils/api";
import {
  MdArrowBack,MdEdit
} from "react-icons/md";
export default function UserDetails() {
  const { id } = useParams();
  const navigate = useNavigate();
  const [user, setUser] = useState(null);

  const loadUser = async () => {
    try {
      const res = await api.post("/list_single_user", { user_id: id });
      setUser(res.data[0]);
    } catch (err) {
      console.error(err);
      toast.error("Failed to load user details");
    }
  };

  useEffect(() => {
    loadUser();
  }, [id]);

  if (!user)
    return <div className="p-6 text-gray-600">Loading...</div>;

  return (

    <div className="mt-8 w-full rounded-2xl bg-white border border-gray-200 shadow-sm p-8">

      {/* Header */}
      <div className="flex flex-col md:flex-row md:items-center md:justify-between gap-4 mb-8">
        <div className="flex items-center gap-3">
          <button
            onClick={() => navigate("/admin/admins")}
            className="flex h-9 w-9 items-center justify-center rounded-lg border border-gray-200 bg-white text-gray-600 shadow-sm transition hover:border-gray-300 hover:bg-gray-50"
            aria-label="Back to Runner Boys"
          >
            <MdArrowBack className="h-5 w-5" />
          </button>
          <div>
            <h1 className="text-xl font-bold text-gray-900 sm:text-2xl">
              User Details
            </h1>
            <p className="text-sm text-gray-500 mt-1">
              Overview of user information
            </p>
          </div>
        </div>


        <div className="flex items-center gap-3">

          {/* Status Badge */}
          <span
            className={`px-3 py-1 text-xs font-medium rounded-full border ${user.status === 1
                ? "bg-green-100 text-green-700 border-green-300" 
                : "bg-rose-50 text-rose-600 border-rose-200"    
              }`}
          >
            {user.status === 1 ? "Active" : "Inactive"}
          </span>

          {/* Edit Button */}
          <button
  onClick={() => navigate(`/admin/edit_user/${user.id}`)}
  className="flex items-center gap-2 rounded-lg bg-brand-500
      px-5 py-2.5 text-sm font-semibold text-white
      shadow-sm transition-all duration-200 
      hover:shadow-md hover:scale-[1.02]"
>
  <MdEdit className="w-4 h-4" />
  Edit Details
</button>
        </div>
      </div>

      {/* Details Grid */}
      <div className="grid md:grid-cols-2 gap-y-8 gap-x-12">

        <div>
          <p className="text-xs font-medium tracking-wide text-gray-400 uppercase mb-2">
            Full Name
          </p>
          <p className="text-base font-semibold text-gray-800">
            {user.name}
          </p>
        </div>

        <div>
          <p className="text-xs font-medium tracking-wide text-gray-400 uppercase mb-2">
            Email Address
          </p>
          <p className="text-base font-semibold text-gray-800">
            {user.email}
          </p>
        </div>

        <div>
          <p className="text-xs font-medium tracking-wide text-gray-400 uppercase mb-2">
            Mobile Number
          </p>
          <p className="text-base font-semibold text-gray-800">
            {user.mobile_no}
          </p>
        </div>

        <div>
          <p className="text-xs font-medium tracking-wide text-gray-400 uppercase mb-2">
            Role
          </p>
          <p className="text-base font-semibold text-gray-800">
            {user.role === "R" ? "Runner" : "Administrator"}
          </p>
        </div>

      </div>

      {/* Divider */}
      <div className="border-t border-gray-200 my-8"></div>



    </div>

  );
}